// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стили для Google Maps компонента */
/* Основные стили управляются через React props */

.google-map__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.google-map__title {
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 30px 0;
  text-align: center;
  /* Цвет управляется через React props */
}

.google-map__wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: var(--color-card-background, #f8f8f8);
}

.google-map__iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.google-map__loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 14px;
  color: var(--color-text-secondary, #666);
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.google-map__placeholder {
  padding: 80px 40px;
  text-align: center;
  background: #f8f9fa;
  border-radius: 12px;
  border: 2px dashed #ddd;
}

.google-map__placeholder h3 {
  color: #333;
  font-size: 24px;
  margin: 0 0 15px 0;
}

.google-map__placeholder p {
  color: #666;
  font-size: 16px;
  margin: 0 0 10px 0;
}

.google-map__placeholder small {
  color: #999;
  font-size: 14px;
  font-style: italic;
}

.google-map__iframe:not([src=""]) + .google-map__loading {
  opacity: 0;
}

/* Адаптивный дизайн */
@media screen and (max-width: 768px) {
  .google-map {
    padding: 30px 0;
  }
  
  .google-map__container {
    padding: 0 16px;
  }
  
  .google-map__title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .google-map__wrapper {
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }
}

@media screen and (max-width: 480px) {
  .google-map {
    padding: 20px 0;
  }
  
  .google-map__title {
    font-size: 20px;
    margin-bottom: 16px;
  }
  
  .google-map__wrapper {
    border-radius: 6px;
  }
  
  .google-map__loading {
    padding: 12px 16px;
    font-size: 13px;
  }
}

/* Темная тема */
@media (prefers-color-scheme: dark) {
  .google-map {
    background: var(--color-background-dark, #1a1a1a);
  }
  
  .google-map__title {
    color: var(--color-heading-dark, #fff);
  }
  
  .google-map__wrapper {
    background: var(--color-card-background-dark, #2a2a2a);
  }
  
  .google-map__loading {
    background: rgba(42, 42, 42, 0.95);
    color: var(--color-text-secondary-dark, #ccc);
  }
}

/* Высокий контраст */
@media (prefers-contrast: high) {
  .google-map__wrapper {
    border: 2px solid #000;
  }
  
  .google-map__loading {
    background: #fff;
    color: #000;
    border: 1px solid #000;
  }
}

/* Печать */
@media print {
  .google-map__iframe {
    display: none;
  }
  
  .google-map__loading {
    display: none;
  }
  
  .google-map__wrapper::after {
    content: "Карта доступна в онлайн версии";
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: #f5f5f5;
    color: #666;
    font-size: 14px;
  }
}

/* Анимации */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.google-map__wrapper {
  animation: fadeIn 0.6s ease-out;
}

/* Уменьшенное движение */
@media (prefers-reduced-motion: reduce) {
  .google-map__wrapper {
    animation: none;
  }
  
  .google-map__loading {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GoogleMap.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC,iDAAiD;;AAEjD;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,iDAAiD;EACnD;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,kCAAkC;IAClC,6CAA6C;EAC/C;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,aAAa;AACb;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Стили для Google Maps компонента */\n/* Основные стили управляются через React props */\n\n.google-map__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.google-map__title {\n  font-size: 32px;\n  font-weight: 700;\n  margin: 0 0 30px 0;\n  text-align: center;\n  /* Цвет управляется через React props */\n}\n\n.google-map__wrapper {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  background: var(--color-card-background, #f8f8f8);\n}\n\n.google-map__iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n}\n\n.google-map__loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.9);\n  padding: 16px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  color: var(--color-text-secondary, #666);\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.google-map__placeholder {\n  padding: 80px 40px;\n  text-align: center;\n  background: #f8f9fa;\n  border-radius: 12px;\n  border: 2px dashed #ddd;\n}\n\n.google-map__placeholder h3 {\n  color: #333;\n  font-size: 24px;\n  margin: 0 0 15px 0;\n}\n\n.google-map__placeholder p {\n  color: #666;\n  font-size: 16px;\n  margin: 0 0 10px 0;\n}\n\n.google-map__placeholder small {\n  color: #999;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.google-map__iframe:not([src=\"\"]) + .google-map__loading {\n  opacity: 0;\n}\n\n/* Адаптивный дизайн */\n@media screen and (max-width: 768px) {\n  .google-map {\n    padding: 30px 0;\n  }\n  \n  .google-map__container {\n    padding: 0 16px;\n  }\n  \n  .google-map__title {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n  \n  .google-map__wrapper {\n    border-radius: 8px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .google-map {\n    padding: 20px 0;\n  }\n  \n  .google-map__title {\n    font-size: 20px;\n    margin-bottom: 16px;\n  }\n  \n  .google-map__wrapper {\n    border-radius: 6px;\n  }\n  \n  .google-map__loading {\n    padding: 12px 16px;\n    font-size: 13px;\n  }\n}\n\n/* Темная тема */\n@media (prefers-color-scheme: dark) {\n  .google-map {\n    background: var(--color-background-dark, #1a1a1a);\n  }\n  \n  .google-map__title {\n    color: var(--color-heading-dark, #fff);\n  }\n  \n  .google-map__wrapper {\n    background: var(--color-card-background-dark, #2a2a2a);\n  }\n  \n  .google-map__loading {\n    background: rgba(42, 42, 42, 0.95);\n    color: var(--color-text-secondary-dark, #ccc);\n  }\n}\n\n/* Высокий контраст */\n@media (prefers-contrast: high) {\n  .google-map__wrapper {\n    border: 2px solid #000;\n  }\n  \n  .google-map__loading {\n    background: #fff;\n    color: #000;\n    border: 1px solid #000;\n  }\n}\n\n/* Печать */\n@media print {\n  .google-map__iframe {\n    display: none;\n  }\n  \n  .google-map__loading {\n    display: none;\n  }\n  \n  .google-map__wrapper::after {\n    content: \"Карта доступна в онлайн версии\";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    background: #f5f5f5;\n    color: #666;\n    font-size: 14px;\n  }\n}\n\n/* Анимации */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.google-map__wrapper {\n  animation: fadeIn 0.6s ease-out;\n}\n\n/* Уменьшенное движение */\n@media (prefers-reduced-motion: reduce) {\n  .google-map__wrapper {\n    animation: none;\n  }\n  \n  .google-map__loading {\n    transition: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
